type PagesDataState = {
  auxiliaryData: unknown
}

export const state = (): PagesDataState => {
  return {
    auxiliaryData: null,
  }
}

export const getters = {
  GET_AUXILIARY_DATA: (state: PagesDataState) => state.auxiliaryData,
}

export const mutations = {
  SET_PAGES_DATA_KEY(
    state: PagesDataState,
    payload: { key: keyof PagesDataState; data: unknown }
  ) {
    state[payload.key] = payload.data
  },
}
